import {Lightbox} from "../../classes/Lightbox";

const titleAttribute = 'data-promotion-title';
const descriptionAttribute = 'data-promotion-description';
const urlAttribute = 'data-promotion-url';

const stickerSelector = `li.promotion[${titleAttribute}][${descriptionAttribute}][${urlAttribute}]`;

const createLightboxContentTemplate = ( title, description, url ) => {
	return (`
		<div class="sticker-content">
			<h2>${title}</h2>
			<p>${description}</p>
			<a href="${url}">Подробности акции</a>
		</div>
	`);
}

const initStickers = ( component ) => {
	component && component.addEventListener( 'click', ( evt ) => {
		const sticker = evt.target.closest( stickerSelector );
		
		if ( sticker )
		{
			const title = sticker.getAttribute( titleAttribute );
			const description = sticker.getAttribute( descriptionAttribute );
			const url = sticker.getAttribute( urlAttribute );
			
			Lightbox.open(
				createLightboxContentTemplate( title, description, url),
				null,
				'sticker'
			);
		}
	} );
};

export {
	initStickers,
};
